import { FC } from 'react';

import CreateJoiningLinkForm from '@/components/layout/createJoiningLinkPage/CreateJoiningLinkForm.tsx';

const CreateJoiningLink: FC = () => {
  return (
    <div className="w-full max-w-2xl mx-auto md:ml-10 xl:ml-28 mt-8 md:mt-12 flex flex-col md:flex-row gap-4 px-4 items-start">
      <div className="flex-1 w-full text-center md:text-left">
        <CreateJoiningLinkForm />
      </div>
    </div>
  );
};

export default CreateJoiningLink;
